/* import __COLOCATED_TEMPLATE__ from './url-visit-editor.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import BaseEditor from './base-editor';
import { action } from '@ember/object';
export default BaseEditor.extend({
  changeCount: action(function (count) {
    this.changePredicateValue({
      url: this.get('predicate.value.url'),
      count
    });
  }),
  changeUrl: action(function (url) {
    if (event.type === 'keyup' && event.keyCode !== 13) {
      return;
    }
    this.changePredicateValue({
      url,
      count: this.get('predicate.value.count')
    });
  })
});